module.exports = __webpack_public_path__ + "static/media/7@3x.aaeccd4b.png";